import { render, staticRenderFns } from "./NumberStep.vue?vue&type=template&id=a47d891e&"
import script from "./NumberStep.vue?vue&type=script&lang=js&"
export * from "./NumberStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports